// extracted by mini-css-extract-plugin
export default {"ImageX":"lyNaha","imageX":"lyNaha","responsiveImg":"JdNFxG","imageStyling":"h1DYhE","imageLayer":"Ux33nC","linkedImage":"QebvG3","ImageXLegacy":"YCPMeD","imageXLegacy":"YCPMeD"};